module.exports = __webpack_public_path__ + "static/media/Discode.2e05282f.png";